import { Home } from "./pages/Home";
import { NotFound } from "./pages/NotFound";
import React, { useEffect } from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./assets/fonts/Poppins-Regular.ttf";
import "./assets/fonts/Poppins-Medium.ttf";
import "./assets/fonts/Poppins-Light.ttf";
import "./assets/fonts/Poppins-Bold.ttf";

import { MainLayout } from "./layouts/MainLayout";
import { SecondLayout } from "./layouts/SecondLayout";
import { Mapex } from "./pages/Mapex";
import { Cards } from "./pages/Cards";
import { Plans } from "./pages/Plans";
import { Wallet } from "./pages/Wallet";
import { Activity } from "./pages/Activity";
import { Account } from "./pages/Account";
import { Login } from "./auth/Login";
import { Register } from "./auth/Register";
import CryptoAddressPage from "./pages/CryptoAddressPage";
import TransactionDetails from "./pages/TransactionDetails";
import ProfilePage from "./pages/Profile";
import InvestmentDashboard from "./pages/InvestmentDashboard/InvestmentDashboard";
import { Splash } from "./auth/Splash";
import { useAuthStore } from "./store";

// Simplified protected route component
const ProtectedRoute = ({ children, layout: Layout }) => {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return Layout ? <Layout>{children}</Layout> : children;
};

// Public route component
const PublicRoute = ({ children, layout: Layout }) => {
  const { user } = useAuthStore();

  if (user) {
    return <Navigate to="/home" replace />;
  }

  return Layout ? <Layout>{children}</Layout> : children;
};

function App() {
  const theme = localStorage.getItem("theme") || "theme-dark";

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <Splash />
          </PublicRoute>
        }
      />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />

      {/* Protected Routes with MainLayout */}
      <Route
        path="/home"
        element={
          <ProtectedRoute layout={MainLayout}>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wallet"
        element={
          <ProtectedRoute layout={MainLayout}>
            <Wallet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mapex"
        element={
          <ProtectedRoute layout={MainLayout}>
            <Mapex />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes with SecondLayout */}
      <Route
        path="/activity"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <Activity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cards"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <Cards />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <Account />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crypto-address"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <CryptoAddressPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/transaction-detail"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <TransactionDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/investment-dashboard"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <InvestmentDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/plans"
        element={
          <ProtectedRoute layout={SecondLayout}>
            <Plans />
          </ProtectedRoute>
        }
      />

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
